// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-dialog{box-shadow:none!important}@media only screen and (max-width:600px){.v-dialog{overflow-y:scroll}}", ""]);
// Exports
module.exports = exports;
